import { computed, reactive, toRefs } from 'vue';
import {
  getToken,
  checkToken,
  setRedirectUrl,
  parsedTokenInfo,
  removeToken,
} from '@/services/token';

export interface IUser {
  uid: string;
  firstName: string;
  lastName: string;
  email: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  [propName: string]: any;
}

interface IAuthState {
  isAuthenticated: boolean;
  user?: IUser;
}

const state = reactive<IAuthState>({
  isAuthenticated: false,
  user: undefined,
});

export const useAuth = () => {
  const fullName = computed<string>(() => `${state.user?.firstName} ${state.user?.lastName}`);

  const login = () => {
    window.location.href = process.env.VUE_APP_SIGN_IN_URL;
  };

  const logout = () => {
    state.user = undefined;
    state.isAuthenticated = false;

    removeToken();
    window.location.href = process.env.VUE_APP_LOGOUT_URL;
  };

  const loginSuccess = (token: string) => {
    try {
      state.user = parsedTokenInfo(token);
      state.isAuthenticated = true;
    } catch (error) {
      alert(`Something went wrong while fecthing your user information. ${error}`);
    }
  };

  const checkAuth = () => {
    const checkAuthentication: boolean = checkToken();

    if (checkAuthentication) {
      // if token exists, either in url or storage, and is not expired
      const token: string = getToken();

      loginSuccess(token);
    } else {
      // if token doesn't exist
      setRedirectUrl();
      login();
    }
  };

  return {
    ...toRefs(state),
    fullName,
    loginSuccess,
    checkAuth,
    login,
    logout,
  };
};
